import { render } from "./SurveyResponses.vue?vue&type=template&id=35f2d5ac&scoped=true"
import script from "./SurveyResponses.vue?vue&type=script&lang=js"
export * from "./SurveyResponses.vue?vue&type=script&lang=js"

import "./SurveyResponses.vue?vue&type=style&index=0&id=35f2d5ac&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f2d5ac"]])

export default __exports__